// Module
var code = "<div class=\"objectManager-panel-container-table\">\r\n    <terceraPanel name='windowPanelBodyQT' />\r\n</div>";
// Exports
export default code;